import { LNotification } from "@lib/abpUtility"
import { notifySuccess } from "@lib/helper"
import { downloadFile } from "@lib/helperFile"
import { TradingFloorDetailModel } from "@models/tradingFloor/TradingFloorDetailModel"
import { UseUserInfoTradingFloorModelModel } from "@models/tradingFloor/UserInfoTradingFloorModel"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import http from "@services/httpService"
import dayjs from "dayjs"

class AgencyMasterService {
  public async create(body: any) {
    const result = await http.post(
      "api/services/app/AgencyMasters/Create",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return result.data.result
  }

  public async update(body: any) {
    const result = await http.put("api/services/app/AgencyMasters/Update", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return result.data.result
  }

  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/AgencyMasters/GetAll", {
      params,
    })
    const result = res.data.result

    return result
  }

  public async get(id: number) {
    const res = await http.get("api/services/app/AgencyMasters/Get", {
      params: { id },
    })
    const result = TradingFloorDetailModel.assign(res.data.result)
    return result
  }

  public async deactivate(id) {
    await http.delete("api/services/app/AgencyMasters/Delete", {
      params: { id },
    })
  }

  public async getAllUserByTradingFloorId(
    params: any
  ): Promise<PagedResultDto<any>> {
    const res = await http.get(
      "api/services/app/AgencyMasters/GetUserByAgencyId",
      {
        params,
      }
    )
    const result = res.data.result

    return result
  }

  public async getExistPhone(phone: string) {
    const res = await http.get("api/services/app/AgencyMasters/GetExistPhone", {
      params: { phone },
    })
    const result = UseUserInfoTradingFloorModelModel.assign(res.data.result)
    return result
  }

  public async getListAgencyMaster(params: any): Promise<any[]> {
    const res = await http.get(
      "api/services/app/AgencyMasters/GetListAgencyMaster",
      {
        params,
      }
    )
    const result = res.data.result

    return result
  }

  public async assignUser(body: any) {
    const result = await http.post(
      "api/services/app/AgencyMasters/AssignUser",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return result.data.result
  }

  public async getAllCartByAgencyMaster(
    params: any
  ): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/AgencyMasters/GetCard", {
      params,
    })
    const result = res.data.result

    return result
  }

  public async activateOrDeactivate(id: number, isActive) {
    const res = await http.post(
      "/api/services/app/AgencyMasters/Active",
      { id },
      { params: { isActive } }
    )
    return res.data
  }
  public async getCurrent() {
    const result = await http.get("api/services/app/AgencyMasters/GetCurrent")

    return result.data.result
  }

  public async getListForAdmin(params?): Promise<any> {
    const res = await http.get(
      "api/services/app/AgencyMasters/GetListForAdmin",
      { params }
    )
    const { result } = res.data

    return result
  }

  public async ImportAgencyMaster(file: File) {
    const formData = new FormData()
    formData.append("file", file)
    const result = await http.post("api/Imports/ImportAgencyMaster", formData)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("IMPORT_SUCCESSFULLY")
    )
    return result.data.result
  }

  public async exportTemplateAgencyMaster() {
    const result = await http.get("api/Imports/GetAgencyMasterTemplate", {
      responseType: "blob",
    })
    downloadFile(result.data, `TEMPLATE-AGENCY-MASTER-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
    return result.data
  }

  public async importAgencyMasterUser(file: File, agencyMasterId?: number) {
    const formData = new FormData()
    formData.append("file", file)
    const result = await http.post("api/Imports/ImportAgencyMasterUser", formData, {
      params: { agencyMasterId },
    })
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("IMPORT_SUCCESSFULLY")
    )
    return result.data.result
  }

  public async exportTemplateAgencyMasterUser() {
    const result = await http.get("api/Imports/GetAgencyMasterUserTemplate", {
      responseType: "blob",
    })
    downloadFile(result.data, `TEMPLATE-AGENCY-MASTER-USER-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
    return result.data
  }
}

export default new AgencyMasterService()
